export function axIsTypeObject(x) {
    return this.dPrototype.isPrototypeOf(this.sec.box(x)) || x === this.dPrototype;
}
